module.exports = __webpack_public_path__ + "img/main_00090.eec87bde.png";